module.exports = __webpack_public_path__ + "static/scenario2-thumb-b8398f4de5bad166d4f3c78a7f196282.png";